/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Footer_ExploreInputs */

const en_wc_footer_explore = /** @type {(inputs: Wc_Footer_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore`)
};

/**
* | output |
* | --- |
* | "Explore" |
*
* @param {Wc_Footer_ExploreInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_footer_explore = /** @type {((inputs?: Wc_Footer_ExploreInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Footer_ExploreInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_footer_explore(inputs)
});
export { wc_footer_explore as "wc.footer.explore" }